// instrumentation-client.js
// ════════════════════════════════════════════════════════════════════════
// Next.js client-side instrumentation. Loaded in the browser bundle.
// Mirrors instrumentation.js but for browser-side errors.
//
// Without NEXT_PUBLIC_SENTRY_DSN: Sentry no-ops (silent skip).
// With it: captures unhandled exceptions, promise rejections,
//          and (optional) navigation breadcrumbs.
//
// IMPORTANT: client DSN is PUBLIC by design. NEXT_PUBLIC_SENTRY_DSN
// gets bundled into the JS sent to browsers. That is how Sentry works —
// the DSN identifies the project, it is not a secret. Server-side
// instrumentation uses SENTRY_DSN (no NEXT_PUBLIC_) for clarity.
//
// In practice: set BOTH env vars to the same DSN value in Vercel.
// ════════════════════════════════════════════════════════════════════════

;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs';

if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_VERCEL_ENV || 'development',
    release: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
    // 10% performance sampling
    tracesSampleRate: 0.1,
    // Session replay disabled for now (costs + privacy review needed)
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    // Drop noisy errors as patterns emerge
    ignoreErrors: [
      // Browser-extension noise
      'top.GLOBALS',
      // Random network blips
      'NetworkError when attempting to fetch resource.',
      'Load failed',
    ],
  });
}

// Required by Next.js 15+ to capture client-side router transitions
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
